export function isBusinessCopyPeriodValid(period) {
  const validDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value || "")
    && Number.isFinite(Date.parse(`${value}T00:00:00Z`))
    && new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value;
  return validDate(period?.start_date)
    && (!period?.end_date || (validDate(period.end_date) && period.end_date >= period.start_date));
}

export function formatBusinessCopyPeriod(period) {
  const display = (value) => value?.split("-").reverse().join("-") || "—";
  return period?.end_date
    ? `Du ${display(period.start_date)} au ${display(period.end_date)} inclus`
    : `Depuis le ${display(period?.start_date)}, commandes futures incluses`;
}

export function formatBusinessCopyDuration(seconds) {
  if (!Number.isFinite(seconds)) return "—";
  const rounded = Math.round(seconds);
  return seconds < 60
    ? `${new Intl.NumberFormat("fr-CA", { maximumFractionDigits: 1 }).format(seconds)} s`
    : `${Math.floor(rounded / 60)} min ${rounded % 60} s`;
}
